export const FIELD_LIMITS = {
    AGENCY_NAME: 100,
    PERSON_NAME: 100,
    EMAIL: 256,
    LE_REFERENCE_NUMBER: 100,
    OTHER_DESCRIPTION: 100,
    RECEIVING_AGENT_EMAIL: 50,
    ACKNOWLEDGEMENT: 200,
    NDO_EXTENSIONS: 1000,
    COUNTRY_SEARCH: 100,
    DATA_CATEGORY_OTHER: 200,
    MANUAL_SERVICE: 200,
    DSA_DECLARATION: 2000,
    IDENTIFIER_VALUE: 2048,
} as const;
